<div class="flex flex-col gap-3 w-full py-4 bg-white">
    <!-- Ttile -->
    <div class="flex items-center justify-between w-full">
        <h1 class="text-3xl text-black-500 pdp-title">{{ dataSource?.FullName }}</h1>

        <div class="hidden md:flex items-center gap-4">
            <button *ngIf="type != 2" (click)="addToFavorite()"
                class="rounded-lg border border-solid flex items-center justify-center h-11 w-11 bg-grey-50" matRipple
                #likeBtn>

                <div class="typing-animation scale-[0.65]" *ngIf="loadingFavorite; else toggleFavorite">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <ng-template #toggleFavorite>
                    <div *ngIf="isFavorite && this.authService.getUserData()();else noFavorite" class="filled-heart"
                        style="width:22px"></div>
                    <ng-template #noFavorite>
                        <i class="ico-Heart text-2xl text-black-400"></i>
                    </ng-template>
                </ng-template>

            </button>

            <button (click)="copyToClipboard()"
                class="rounded-lg border border-solid flex items-center justify-center h-11 w-11 bg-grey-50" matRipple>
                <i class="ico-Share text-2xl text-black-400"></i>
            </button>
        </div>
    </div>


    <!-- Hotel's info -->

    <div class="flex flex-col gap-2">
        <div *ngIf="![0,'',null, undefined].includes(+dataSource?.Star?.GradeId!) && dataSource?.Star?.GradeId !== 0"
            class="flex items-center gap-2">
            <i class="ico-Star-bold text-xl text-black-300"></i>
            <span class="text-black-300 text-base">{{ dataSource?.Star?.GradeId }} ستاره</span>
        </div>

        <div class="flex items-center justify-between w-full mb-4">
            <div class="flex items-center gap-2">
                <i class="ico-Location-bold text-xl text-black-300"></i>
                <span class="text-black-300 text-base" [title]="dataSource?.Address?.Address">{{
                    dataSource?.Address?.Address
                    }}</span>
            </div>

            <button mat-button color="primary" class="icon-arrow-button !hidden md:!flex" (click)="goToMap()">
                <span class="text-blue-500 text-sm !font-medium">نمایش {{searchBoxService.accommodation() == 'ecolodge'
                    ? 'اقامتگاه' : 'هتل'}} روی نقشه</span>
                <i class="ico-Left !text-2xl text-blue-500"></i>
            </button>
        </div>



        <!-- rate and comments -->



        <div class="flex items-center gap-2 relative py-2" (click)="showComments($event)" (mouseleave)="closeReviews()">
            <div class="flex items-center gap-2 cursor-pointer" (mouseenter)="showReviews()" #reviewPopUpRef>
                <ng-container *ngIf="dataSource?.Score?.Total! > 0">
                    <span
                        class="w-[44px] h-[44px] text-white text-2xl flex justify-center items-center bg-blue-500 rounded">
                        {{ dataSource?.Score?.ScoreNumber }}
                    </span>
                </ng-container>
                <div class="flex flex-col gap-1 items-start">
                    <span class="text-base text-black-400 !font-semibold cursor-pointer">{{ dataSource?.Score?.Text
                        }}</span>
                    <button class="text-sm text-blue-500 underline hover:text-blue-400 hover:decoration-blue-400">
                        {{ dataSource?.Score?.Total == 0 ? 'بدون نظر' : dataSource?.Score?.Total + 'نظر' }}</button>
                </div>
            </div>

            <iho-pop-up #reviewPopUp [Position]="'top'" [isVisible]="isVisible" [isTooltip]="isTooltip" [top]="-270"
                [right]="0" [classList]="'w-[405px]'" (isOnPopup)="onHotelReviewPopUp.set($event)"
                (closed)="closeReviews()" [popUpTemplate]="hotelReviews" />
        </div>

        <ng-template #hotelReviews>
            <div class="w-96 h-full">
                <iho-pdp-comments-popup />
            </div>
        </ng-template>
    </div>

</div>